import { NgClass } from '@angular/common'
import { Component, Input } from '@angular/core'

export type TagTypes = 'error' | 'info' | 'notice' | 'success' | 'warning'
export type TagSizes = 'default' | 'small' | 'large'

@Component({
  selector: 'app-tag',
  imports: [NgClass],
  templateUrl: './tag.component.html',
})
export class TagComponent {
  @Input() public type!: TagTypes
  @Input() public size: TagSizes = 'default'
  @Input() public close!: boolean
  @Input() public textColor!: string
}
